export function toProperWord(word: string) {
	return word.charAt(0) + word.substring(1).toLowerCase();
}